import type { ProficiencyIconEntry } from '@/constants/proficiencyIconCatalog';

interface ProficiencyIconProps {
    iconEntry?: ProficiencyIconEntry;
    iconUrl?: string | null;
    alt?: string;
    color?: string;
    className?: string;
    /** Intrinsic size in pixels, written as `width`/`height` so an uploaded image reserves its box. */
    size?: number;
    /**
     * Names this icon for tests. A decorative icon carries no accessible name, so without this
     * there is nothing to query it by. Defaults to the catalogue entry it draws.
     */
    dataTestId?: string;
}

export const ProficiencyIcon = ({
    iconEntry,
    iconUrl,
    alt,
    color,
    className = 'h-[20px] w-[20px]',
    size,
    dataTestId,
}: ProficiencyIconProps) => {
    if (iconUrl) {
        return (
            <img
                src={iconUrl}
                alt={alt ?? ''}
                width={size}
                height={size}
                // An uploaded image keeps its ratio inside the square the icon is given.
                className={`${className} object-contain`}
                style={{ color: color ?? '' }}
                data-testid={dataTestId}
            />
        );
    }

    if (!iconEntry) {
        return null;
    }

    return (
        <svg
            // `colorClass` is a class name: it only paints when the level carries no colour of its own.
            className={`${className} ${color ? '' : iconEntry.colorClass}`}
            viewBox={'0 0 24 24'}
            fill={'none'}
            stroke={'currentColor'}
            style={color ? { color } : undefined}
            aria-hidden
            data-testid={dataTestId ?? `proficiency-icon-${iconEntry.value}`}
        >
            {iconEntry.paths}
        </svg>
    );
};
